<div *transloco="let t">
  <div class="portal-header m-xl d-flex flex-column align-items-center">
    <h4>{{ t('Welcome to your application portal.') }}</h4>
    <span>{{ t('Select application to continue.') }}</span>
  </div>
  <div class="cards-container">
    <cw-card
      class="app-card"
      type="horizontal"
      [custom]="true">
      <div slot='custom' class="d-flex">
        <div class="app-logo">
          <cw-image
            width="140px"
            height="140px"
            src="assets/icons/app-icon/bbraun_resi_icon.svg"
            alt="RepEvolution logo"/>
        </div>
        <div class="card-body d-flex flex-column">
          <!--Dev note: Next line is non-translatable-->
          <h2 class="card-title mb-m">REPevolution</h2>
          <div>
            {{ t('Our comprehensive solution empowers you to efficiently manage repairs quick and easy.') }}
          </div>
          <cw-button
            class="action-button align-self-end mt-auto"
            button-color="accent"
            variant="outlined"
            type="button"
            as="button"
            (click)="onRepEvolutionSelected()"
            data-cy="rep-evolution-button">
            {{ t('Continue') }}
          </cw-button>
        </div>
      </div>
    </cw-card>

    <cw-card
      class="app-card"
      type="horizontal"
      [custom]="true">
      <div slot='custom' class="d-flex">
        <div class="app-logo">
          <cw-image
            width="140px"
            height="140px"
            src="assets/icons/app-icon/bbraun_resi_icon.svg"
            alt="Replenishment logo"/>
        </div>
        <div class="card-body d-flex flex-column">
          <!--Dev note: Next line is non-translatable-->
          <h2 class="card-title mb-m">Replenishment</h2>
          <div>
            {{ t("An all-in-one solution for managing customer processes. From repair requests to purchases and tracking.") }}
          </div>
          <cw-button
            class="action-button align-self-end mt-auto"
            button-color="accent"
            variant="outlined"
            type="button"
            as="button"
            (click)="onReplenishmentSelected()"
            data-cy="replenishment-button">
            {{ t('Continue') }}
          </cw-button>
        </div>
      </div>
    </cw-card>
  </div>
</div>
